import { ChangeEvent, Snackbar } from "@mcleod/components";
import { AutogenLayoutFleetCode } from "./autogen/AutogenLayoutFleetCode";
import { DuplicateIdProps, DuplicateId } from "../DuplicateId";
import { CommonDialogs } from "@mcleod/common";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "fleet",
    screenName: "Fleet Code",
    navigateToUrl: "lme/dispatch/asset/FleetCode?mode=update&key="
};

export class FleetCode extends AutogenLayoutFleetCode {

    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
        this.mainDataSource.doBeforeDataSourcePost = async () => {
            if (!this.activeRow.getBoolean("is_tractor") && !this.activeRow.getBoolean("is_driver") && !this.activeRow.getBoolean("is_trailer")) {
                CommonDialogs.showError("You must select at least one of the following: Tractor, Driver, or Trailer.", "Invalid Data");
                return false;
            }
            return true;
        }
    }

    checkboxIsTractorOnChange(event: ChangeEvent) {
        const isTractor = this.checkboxIsTractor.checked;
        this.textboxDailyRevGoal.enabled = this.textboxDailyDistGoal.enabled = isTractor;
    }

}
